import React from 'react';

const Separator = () => (
    <div style={styles.separator}></div>
);

const styles = {
    separator: {
        display: 'block',
        marginTop: '0.8rem',
        marginBottom: '0.8rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderStyle: 'inset',
        width: '80%',
        borderWidth: '1px'
    }
}

export default Separator;